import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { commonStyles } from '../styles';
var shared = {
  rootFontSize: 10,
  sm: 576,
  md: 786,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  borderRadiusS: 0,
  borderRadiusM: 0,
  borderRadiusL: 0,
  spaceXXS: 4,
  spaceXS: 8,
  spaceS: 12,
  spaceM: 16,
  spaceL: 20,
  spaceXL: 24,
  spaceXXL: 32,
  spaceXXXL: 48,
  spaceXXXXL: 64,
  lineAwesome: true,
  margin: function margin(value) {
    return {
      margin: value
    };
  },
  padding: function padding(value) {
    return {
      padding: value
    };
  },
  flex: function flex(value) {
    return {
      flex: value
    };
  },
  displayFlex: function displayFlex() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        align = _ref.align,
        justify = _ref.justify,
        direction = _ref.direction,
        wrap = _ref.wrap,
        flow = _ref.flow;

    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      display: 'flex'
    }, align && {
      alignItems: align
    }), justify && {
      justifyContent: justify
    }), direction && {
      flexDirection: direction
    }), wrap && {
      flexWrap: wrap
    }), flow && {
      flexFlow: flow
    });
  },
  styles: function styles(properties) {
    return commonStyles(properties);
  }
};
export var darkTheme = _objectSpread(_objectSpread({}, shared), {}, {
  mode: 'dark',
  // Primary — vivid teal
  primary: '#00D4AA',
  primaryLight: '#0E2A2E',
  primaryDark: '#00B392',
  // Accent — coral orange for CTAs
  accent: '#FF6B6B',
  accentLight: '#2A1520',
  accentDark: '#E05555',
  greenRaptors: '#00D4AA',
  // Neutral scale — deep navy dark
  gray50: '#0B1120',
  gray100: '#111A2E',
  gray150: '#192340',
  gray200: '#1F2B45',
  gray300: '#2D3B58',
  gray400: '#4A5A7A',
  gray500: '#7B8BA8',
  gray600: '#A0ADCA',
  gray700: '#CBD5E8',
  gray800: '#E8EDF5',
  black: '#F2F5FA',
  white: '#0D1526',
  // Semantic colors
  info: '#38BDF8',
  infoLight: '#0E1E30',
  infoDark: '#0EA5E9',
  warning: '#FBBF24',
  warningLight: '#1E1A0E',
  warningDark: '#F59E0B',
  success: '#34D399',
  successLight: '#0E2420',
  successDark: '#10B981',
  error: '#FB7185',
  errorLight: '#2A1520',
  errorDark: '#F43F5E',
  highlight: '#818CF8',
  purple: '#A78BFA',
  boxShadowLight: '0 1px 3px 0 rgb(0 0 0 / 0.4), 0 1px 2px -1px rgb(0 0 0 / 0.3)',
  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.5), 0 2px 4px -2px rgb(0 0 0 / 0.4)',
  boxShadowMd: '0 10px 15px -3px rgb(0 0 0 / 0.5), 0 4px 6px -4px rgb(0 0 0 / 0.4)',
  boxShadowLg: '0 20px 25px -5px rgb(0 0 0 / 0.6), 0 8px 10px -6px rgb(0 0 0 / 0.5)'
});
export var lightTheme = _objectSpread(_objectSpread({}, shared), {}, {
  mode: 'light',
  // Primary — teal
  primary: '#0D9B7A',
  primaryLight: '#E6F7F3',
  primaryDark: '#087A60',
  // Accent — coral
  accent: '#E05555',
  accentLight: '#FDE8E8',
  accentDark: '#C44040',
  greenRaptors: '#0D9B7A',
  // Neutral scale — clean grays
  gray50: '#F7F8FA',
  gray100: '#EEF0F4',
  gray150: '#E0E3EA',
  gray200: '#CDD2DC',
  gray300: '#9BA3B5',
  gray400: '#6B7588',
  gray500: '#4E5668',
  gray600: '#363D4D',
  gray700: '#232833',
  gray800: '#141720',
  black: '#0A0C12',
  white: '#FFFFFF',
  // Semantic colors
  info: '#2563EB',
  infoLight: '#EFF6FF',
  infoDark: '#1D4ED8',
  warning: '#D97706',
  warningLight: '#FFFBEB',
  warningDark: '#B45309',
  success: '#059669',
  successLight: '#ECFDF5',
  successDark: '#047857',
  error: '#DC2626',
  errorLight: '#FEF2F2',
  errorDark: '#B91C1C',
  highlight: '#6366F1',
  purple: '#8B5CF6',
  boxShadowLight: '0 1px 3px 0 rgb(0 0 0 / 0.08), 0 1px 2px -1px rgb(0 0 0 / 0.06)',
  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.08), 0 2px 4px -2px rgb(0 0 0 / 0.06)',
  boxShadowMd: '0 10px 15px -3px rgb(0 0 0 / 0.08), 0 4px 6px -4px rgb(0 0 0 / 0.06)',
  boxShadowLg: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.08)'
}); // Default export for backward compatibility

export default darkTheme;